import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AiDeleteQuestionChangeStrategy } from '../../../../bases';
import { FillInBlankDescription } from '../components';
import { AiChangeType } from '../../../../../../../ai';
import { jsx as _jsx } from "react/jsx-runtime";
export var FillInBlankDeleteQuestionStrategy = /*#__PURE__*/function (_AiDeleteQuestionChan) {
  _inherits(FillInBlankDeleteQuestionStrategy, _AiDeleteQuestionChan);

  var _super = _createSuper(FillInBlankDeleteQuestionStrategy);

  function FillInBlankDeleteQuestionStrategy(context) {
    _classCallCheck(this, FillInBlankDeleteQuestionStrategy);

    return _super.call(this, context);
  }

  _createClass(FillInBlankDeleteQuestionStrategy, [{
    key: "renderAnswers",
    value: function renderAnswers() {
      var _before$description, _before$index;

      var before = this.context.before;
      return /*#__PURE__*/_jsx(FillInBlankDescription, {
        description: (_before$description = before === null || before === void 0 ? void 0 : before.description) !== null && _before$description !== void 0 ? _before$description : '',
        beforeQuestion: before,
        afterQuestion: before,
        changeType: AiChangeType.Delete,
        startQuestionIndex: (_before$index = before === null || before === void 0 ? void 0 : before.index) !== null && _before$index !== void 0 ? _before$index : 1
      });
    }
  }]);

  return FillInBlankDeleteQuestionStrategy;
}(AiDeleteQuestionChangeStrategy);